import { ChangeEventHandler } from 'react';

import useDisableSystemTemplateMutation from 'components/domain/automation/systemTemplates/useDisableSystemTemplateMutation';
import useEnableSystemTemplateMutation from 'components/domain/automation/systemTemplates/useEnableSystemTemplateMutation';
import useSystemTemplateToggleUtils from 'components/domain/automation/systemTemplates/useSystemTemplateToggleUtils';
import { SystemTemplates } from 'models/automation/SystemTemplates';

/**
 * This will optimistically update the toggle state by changing the query client
 * cache.
 */
const useStatusCellToggle = ({ key }: { key: SystemTemplates }) => {
  const { onMutateFactory, onError, onSettled } =
    useSystemTemplateToggleUtils();
  const { mutate: enableSystemTemplate } = useEnableSystemTemplateMutation({
    onMutate: onMutateFactory({ keys: [key], enabled: true }),
    onError,
    onSettled,
  });
  const { mutate: disableSystemTemplate } = useDisableSystemTemplateMutation({
    onMutate: onMutateFactory({ keys: [key], enabled: false }),
    onError,
    onSettled,
  });

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const isInputChecked = event.target.checked;

    if (isInputChecked) {
      enableSystemTemplate({ key });
    } else {
      disableSystemTemplate({ key });
    }
  };

  return { onChange };
};

export default useStatusCellToggle;
